module.exports = __webpack_public_path__ + "img/material.09f5932f.png";